<template>
  <div id="maintain-area">
    <div class="desktop">
      <div class="d-flex bg">
        <div class="" style="width: 40%;">
          <img src="@/assets/images/maintain/left_alert.webp" style="paddint-top: 10px;width: 100%">
        </div>
        <div class="" style="width: 60%;">
          <div class="d-flex flex-column mb-3">
            <div class="px-4 pt-2" />
            <div class="px-4">
              <img
                class="mr-3"
                src="@/assets/images/maintain/maintaining.webp"
                style="width: 100%;"
              >
            </div>
            <div class="px-4 nl2br" style="color:white;height: 120px;overflow:auto;">
              {{ message }}
            </div>
            <div class="px-4">
              <div class="d-flex align-items-center">
                <div class="p-2 mr-4">
                  <a href="/">
                    <img src="@/assets/images/maintain/back.webp" style="width: 42px">
                  </a>
                </div>
                <div class="p-2">
                  <button v-if="csUrl" class="service-btn border-0" style="width: 140px" @click="goService()">
                    {{ contanctService }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile text-center">
      <img class="warningImg" src="@/assets/images/maintain/left_alert.webp">
      <div class="px-4 pt-2">
        <div class="d-flex justify-content-center align-items-center">
          <div>
            <img v-if="this.$store.getters.brand.image !== undefined" :src="this.$store.getters.brand.image" style="width: 150px; height: 40px;">
            <img v-else src="@/assets/images/default_logo.webp" style="width: 150px; height: 40px;">
          </div>
          <div>
            <img
              v-if="$store.getters.permissionInfo.enable_sponsor"
              class="ml-1"
              src="@/assets/images/sponsor/img_login_sponsor.webp"
              style="width: 60%;"
            >
          </div>
        </div>
      </div>
      <div class="px-4">
        <img
          class="mr-3"
          src="@/assets/images/maintain/maintaining.webp"
          style="width: 100%;"
        >
      </div>
      <div class="mt-10 lead">
        <p class="mb-75 nl2br errMsg">
          {{ message }}
        </p>
        <div class="row d-inline-flex text-center">
          <div class="d-flex align-items-center mr-25">
            <a href="/">
              <img id="previousBtn" src="@/assets/images/maintain/back.webp">
              <br>
              <small>
                {{ returnLabel }}
              </small>
            </a>
          </div>

          <div class="d-flex align-items-center ml-50">
            <a v-if="csUrl" id="csUrlBtn" target="_blank" :href="csUrl" class="px-4 py-3">
              <b>
                <u>{{ contanctService }}</u>
              </b>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/error.css'

export default {
  name: 'Error',
  data() {
    return {
      message: this.$te('Bao.sorry_for_the_error') ? this.$t('Bao.sorry_for_the_error') : 'Error',
      contanctService: this.$te('Bao.contanct_service') ? this.$t('Bao.contanct_service') : 'Service',
      returnLabel: this.$te('Bao.return_back') ? this.$t('Bao.return_back') : 'Return',
      csUrl: false
    }
  },
  created() {
    if (this.$store.state.brand.urlInfo.csUrl !== null) {
      this.csUrl = this.$store.state.brand.urlInfo.csUrl
    } else {
      this.csUrl = 'https://kiifssbyt.chatnow.mstatik.com/widget/standalone.html?eid=1515bdfbfd2280309775d317c9901c9e'
    }
    this.message = this.$store.getters.errorMessage ? this.$store.getters.errorMessage : this.$t('Bao.sorry_for_the_error')
    this.$store.commit('SET_ERROR_MESSAGE', null)
  },
  mounted() {
    document.body.classList.add('error_body')
  },
  destroyed() {
    document.body.classList.remove('error_body')
  },
  methods: {
    goService() {
      window.open(this.csUrl, '_blank')
    }
  }
}
</script>

<style scoped>

/* 維護頁css */

#maintain-area {
  background-color: #040a22;
  height: 100vh;
}

#maintain-area .bg {
  /* background-image: url("~@/assets/images/maintain/background.webp"); */
  height: 100%;
  width: 1000px;
  margin: 0 auto;
  padding-top: 180px;
  padding-bottom: 0px;
  padding-left: 180px;
  padding-right: 180px;
  background-size: 100%;
  background-position: cover;
  background-repeat: no-repeat;
}

.service-btn {
  background: linear-gradient(90deg,#00b7c3 0,#00ceb0);
  color: #fff;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;
  padding: 12px;
}

* {
  color: #FFF;
}

#csUrlBtn {
  background: linear-gradient(90deg,#00b7c3 0,#00ceb0);
  border-radius: 5px;
  line-height: 1;
}

.errMsg {
  font-family: 'Kanit', sans-serif;
  line-height: 1.1 !important;
  font-size: 0.8em;
}

@media only screen and (max-width: 576px) {
  .warningImg {
    width: 60%;
  }

  .errMsg {
    font-size: 0.7em;
    padding-left: 50px;
    padding-right: 50px;
  }

  #previousBtn {
    width: 60%;
  }

  #csUrlBtn {
    font-size: 0.8em;
  }
}

@media only screen and (min-width: 577px) and (max-width: 768px) {
  .warningImg {
    width: 60%;
  }

  .errMsg {
    font-size: 0.5em;
    padding-left: 50px;
    padding-right: 50px;
  }

  #previousBtn {
    width: 60%;
  }

  #csUrlBtn {
    font-size: 1em;
  }
}

.desktop {
  height: 100vh;
}

.mobile {
  padding-top: 15%;
  display: none;
}

@media only screen and (max-width: 900px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}

</style>
